/**
 * Página de Cadastro de Cliente
 */

import React from 'react';
import { Layout } from '@components';
import CadCliente from '../components/cliente/CadCliente';

const CadClientePage: React.FC = () => {
  return (
    <Layout title="Cadastrar Cliente" showHeader showFooter footerType="cliente">
      <CadCliente />
    </Layout>
  );
};

export default CadClientePage;
